import { render, staticRenderFns } from "./ListReturn.vue?vue&type=template&id=6b1e2da6&lang=pug&"
import script from "./ListReturn.vue?vue&type=script&lang=ts&"
export * from "./ListReturn.vue?vue&type=script&lang=ts&"
import style0 from "./ListReturn.vue?vue&type=style&index=0&id=6b1e2da6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports